class Retry {
    constructor(config,report) {
    	this.list  = [];
        this.tickHandler = 0;
        this.trytime =  config.tryTime || 8;
        this.report = report;
    } 

    add(data) {
    	if(data.id == -1) return;
        data.trycount = 1;
        data.time = 0;
        data.paramlist  = data.paramlist || [data.servantName, data.funcName, data.data,data.id,data.callbackFun];
        //id:iRequestId,reSend:this._sendWup,servantName:servantName,funcName:funcName,data:data,tryCountMax:tryCount,errFun:_this.sendErr,callbackFun:callback
        this.list.push(data);
        this.turnOn();
    }

    getCallBack(id){
        for(let i  in this.list){
            if(this.list[i].id == id){
                return this.list[i].callbackFun;
            }
        }
        return null;
    }

    del(id){
    	if(id == -1) return;
    	for(let i  in this.list){
    		if(this.list[i].id == id){
    			this.list.splice(i, 1);
    			break;
    		}
    	}
    }

    getDataById(id){
    	for(let i  in this.list){
    		if(this.list[i].id == id){
    			return this.list[i];
    		}
    	}
    	return null;
    }

    loop(){
        let removeList = [];
        for(let i in this.list){
        	var info = this.list[i];
        	if(info.time < this.trytime){
               info.time++;
        	}else{
        	   info.trycount++;
        	   info.time = 0;
        	   if(info.trycount > info.tryCountMax){
                  //超过次数处理当做error
                  info.errFun(info);
                  //从列表删除处理
                  removeList.push(info.id);
        	   }else{
        	   	  //执行回调方法，重新发送
        	   	  let param = info.paramlist;
                  if(info.reSend){
        	   	      info.reSend.apply(null, param);
                  }
                  this.report.setDim(info.id,"trycount",info.trycount);
        	   }
        	}
        }
        for(let i in removeList){
            this.del(removeList[i]);
        }
        if(this.list.length == 0) this.turnOff();
    }

    turnOn() {
        if (this.tickHandler == 0) {
            this.tickHandler = setInterval(()=>{
                this.loop();
            }, 1000);
        }
    }

    turnOff(){
    	clearInterval(this.tickHandler);
        this.tickHandler = 0;
    }

 }

 export default Retry;